// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/communication-tool/communication-tool-filter/communication-tool-filter.scss
// module id = 500
// module chunks = 0